import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
// Rxjs
import { Observable } from 'rxjs';
import { TenantConfService } from 'src/app/services/tenant-conf.service';
// ENV
import {  DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LanguageInterceptor implements HttpInterceptor {
  constructor(
    @Inject(DOCUMENT) private document: any,
    private tenantService: TenantConfService,
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const includeAssets = request.url.includes('assets');
    const includeSitum = request.url.includes('situm');
    const includeTracking = request.url.includes('tracking');
    const includeBlog = request.url.includes('wp-json');

    if (includeSitum || includeTracking || includeBlog) {
      return next.handle(request);
    }

    const lang = this.getLanguage();
    const hasLanguage = request.url.includes('v1');
    if (lang && !hasLanguage) {
      request = request.clone({
        setHeaders: {
          Language: `${lang}`
        }
      });
    }

    return next.handle(request);
  }

  getLanguage() {
    return this.document.location.pathname.split('/')[1] || this.tenantService.getTenantDefaultLanguage();
  }
}
